import {makeStyles} from '@material-ui/core/styles';

export default makeStyles(theme => ({
  title: {
    padding: theme.spacing(1),
    textAlign: 'center'
  },
  usersContainer: {
    overflow: 'auto',
    height: '68vh',
  },
  metaDeliveriesContainer: {
    overflow: 'auto',
    height: '60vh',
  },
  deliveriesContainer: {
    overflow: 'auto',
    height: props => props?.height ?? '68vh',
  },
  queueContainer: {
    overflow: 'auto',
    height: '68vh',
  },
  eventContainer: {
    overflow: 'auto',
    height: '72vh',
  },
  tableContainer: {
    overflow: 'auto',
  },
  header: {
    padding: theme.spacing(1),
    marginBottom: theme.spacing(1),
    marginLeft: `-${theme.spacing(1)}px`
  },
  spinner: {
    margin: 50,
    alignSelf: 'center',
  },
  maxEnrolled: {
    backgroundColor: theme.palette.secondary[theme.palette.type],
    paddingRight: theme.spacing(1)
  }
}));

export const tableStyles = makeStyles(theme => (
  {
    table: {
      fontFamily: theme.typography.fontFamily,
    },
    flexContainer: {
      display: 'flex',
      alignItems: 'center',
      boxSizing: 'border-box',
    },
    tableColumn: {
      whiteSpace: 'nowrap',
      overflow: 'auto',
      textOverflow: 'ellipsis',
    },
    tableRow: {
      cursor: 'pointer',
    },
    tableRowHover: {
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
      },
    },
    tableCell: {
      flex: 1,
    },
    noClick: {
      cursor: 'initial',
    },
    noRows: {
      flexGrow: 1,
      textAlign: 'center',
      // overflow: 'hidden'
    },
  }
));

